import { Component, inject, Input } from '@angular/core';
import { L10n, L10nBase } from '@skylab-angular-shared/core';
import { SpinnerComponent } from '../spinner/spinner.component';;
@Component({
    selector: 'skl-loader',
    templateUrl: './loader.component.html',
    styles: [`
        :host {
            display: flex;
            color: var(--text-minor-color);
            font-size: 0.9em;
            height: 46px;
            margin-block: var(--gutter-tiny);
        }

        .item {
            position: relative;
            margin: auto;
        }
    `],
    imports: [SpinnerComponent]
})
export class LoaderComponent {

    @Input() public text: string = (inject(L10n) as L10nBase)._T('ui.loader.loading');
}
